import { encodeBreadcrumbListToJsonLdString } from '@vs-shop/schemas/metadata/breadcrumbList';

import { getDefaultTenantIdentity } from '../../../config/tenant';
import { Url } from '../../../route/router';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../utils/intl';

import type { BreadcrumbItemData } from './Breadcrumbs';

type Props = {
  breadcrumbs: BreadcrumbItemData[];
  currentName: string;
};

export default function BreadcrumbMetadata({ breadcrumbs, currentName }: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  const baseUrl = getDefaultTenantIdentity().host;
  const breadcrumbJsonLd = encodeBreadcrumbListToJsonLdString([
    {
      url: `${baseUrl}${Url.home}`,
      name: intl.formatMessage({
        id: 'breadcrumbs.link.home',
        defaultMessage: 'Domovská stránka',
      }),
    },
    ...breadcrumbs.map((breadcrumb) => ({
      url: `${baseUrl}${breadcrumb.href}`,
      name: breadcrumb.name,
    })),
    {
      name: currentName,
    },
  ]);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: breadcrumbJsonLd.replace(/</g, '\\u003c'),
      }}
    />
  );
}
